function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 4C1 3.26363 1.59695 2.66667 2.33333 2.66667H2.95309C3.39889 2.66667 3.8152 2.44387 4.06249 2.07294L4.60418 1.2604C4.85147 0.889473 5.26777 0.666672 5.71358 0.666672H8.28642C8.73223 0.666672 9.14853 0.889473 9.39582 1.2604L9.93751 2.07294C10.1848 2.44387 10.6011 2.66667 11.0469 2.66667H11.6667C12.403 2.66667 13 3.26363 13 4V10C13 10.7364 12.403 11.3333 11.6667 11.3333H2.33333C1.59695 11.3333 1 10.7364 1 10V4Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 6.66667C9 7.77124 8.10457 8.66667 7 8.66667C5.89543 8.66667 5 7.77124 5 6.66667C5 5.5621 5.89543 4.66667 7 4.66667C8.10457 4.66667 9 5.5621 9 6.66667Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f1ef92a2.svg";
export { ForwardRef as ReactComponent };